module.exports = {"id":"207472","name":"Gōtoku Sakai","rating":"74","photo":"./data/images/photos/1/207472.png","club":{"name":"Hambourg SV","logo":"./data/images/clubs/HambourgSV.png"},"positions":["DD","MDC","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GotokuSakai0.json
// module id = 1630
// module chunks = 0